import { LinkIcon } from "@pathwright/pathicons"
import useCopyToClipboard from "@pathwright/utils/src/clipboard/useCopyToClipboard"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import LinkButton from "./LinkButton"

export const useCopyLink = (value) => {
  const { tc } = useTranslate()
  const copyToClipboard = useCopyToClipboard()

  return (altValue) => {
    // If both value and altValue are provided, prefer value.
    // Wouldn't make sense for both to be provided.
    const copyValue = value || altValue

    // Check if copyValue value is invalid.
    if (typeof copyValue !== "string") {
      throw new Error("No link provided to copy.")
    }

    copyToClipboard(copyValue, {
      title: tc("share_card.link_tab.actions.Copy link.linkCopied"),
      description: null
    })
  }
}

const CopyLink = ({ url }) => {
  const { tc } = useTranslate()
  const handleCopy = useCopyLink(url)

  return (
    <LinkButton
      label={tc("share_card.link_tab.actions.Copy link.buttonLabel")}
      icon={<LinkIcon />}
      onClick={handleCopy}
    />
  )
}

export default CopyLink
